import { SET_ADD_EDIT, RESET_ADD_EDIT } from '../actionTypes/ATCInterstitialActionTypes';

const ATCInterstitialReducer = function ATCInterstitialReducer(state = {}, action) {
    switch (
        action.type // NOSONAR
    ) {
        case SET_ADD_EDIT:
            return {
                ...state,
                isAddorEdit: true,
            };
        case RESET_ADD_EDIT:
            return {
                ...state,
                isAddorEdit: false,
            };
        default:
            return state;
    }
};

ATCInterstitialReducer.reducerName = 'isAddEditSlider';

export default ATCInterstitialReducer;
